export default __webpack_public_path__ + "static/media/IMG-20241005-WA0041.9a36d006.jpg";